import React from 'react';
import Marquee from 'react-fast-marquee';

const AGENT_LABELS = {
  system: 'WAR ROOM',
  researcher: 'LEGISLATIVE RESEARCHER',
  validator: 'STANDING VALIDATOR',
  procedural: 'PROCEDURAL SPECIALIST',
  ecologist: 'ECO-SCIENTIST',
  opposition: 'OPPOSITION ANALYST',
  reconciliation: 'RECONCILIATION',
  translator: 'PLAIN-LANGUAGE TRANSLATOR',
};

const AGENT_COLORS = {
  system: 'text-white',
  researcher: 'text-plai-teal',
  validator: 'text-plai-gold',
  procedural: 'text-plai-purple',
  ecologist: 'text-plai-teal',
  opposition: 'text-red-400',
  reconciliation: 'text-plai-gold',
  translator: 'text-white',
};

export const LiveDebateTicker = ({ events = [], active = false }) => {
  const items = events.length > 0 ? events : [
    { agent: 'system', message: 'Six agents standing by' },
  ];

  return (
    <div className="relative iridescent-border bg-black py-3 overflow-hidden" data-testid="live-debate-ticker">
      <div className="absolute left-3 top-1/2 -translate-y-1/2 z-10 bg-black px-2 py-1">
        <span className={`font-headings text-xs tracking-[0.2em] ${active ? 'text-plai-cta animate-pulse' : 'text-white/40'}`}>
          {active ? 'DEEP SEARCH ACTIVE' : 'WAR ROOM IDLE'}
        </span>
      </div>
      <div className="pl-44">
        <Marquee speed={45} gradient={false} pauseOnHover={false}>
          {items.map((e, i) => (
            <span key={i} className="font-body text-xs tracking-wide mx-8 inline-flex items-center gap-2">
              <span className={`uppercase ${AGENT_COLORS[e.agent] || 'text-white/60'}`}>[{AGENT_LABELS[e.agent] || e.agent}]</span>
              <span className="text-white/80">{e.message}</span>
            </span>
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default LiveDebateTicker;
